import { DeleteIconButton, notify } from '@/components';
import { Trans, useTranslation } from 'react-i18next';
import { array } from '@/utils';
import { Button, Row, Space, Typography } from 'antd';
import {
  ExternalDocumentState,
  useDeleteExternalDocumentMutation,
  useGetExternalDocumentListQuery,
} from '@/redux/externalDocuments';
import { LinkOutlined } from '@ant-design/icons';
import { AddExternalDocumentButton } from '../ExternalDocuments.Details/AddExternalDocumentModalPanel';
import styles from './ExternalDocuments.module.scss';

interface Props {
  referenceId: string;
  showAdd?: boolean;
}

const { Text } = Typography;

export function ExternalDocumentListPanel(props: Props) {
  const { referenceId, showAdd = true } = props;
  const { t } = useTranslation();

  const { data = array.empty<ExternalDocumentState>() } =
    useGetExternalDocumentListQuery({
      referenceIds: [referenceId],
    });

  const [deleteDoc] = useDeleteExternalDocumentMutation();

  const handleDelete = (doc: ExternalDocumentState) =>
    deleteDoc({ id: doc.id })
      .unwrap()
      .then(() => notify.success.t('externalDocuments.details.deleted'));

  const handleOpen = (doc: ExternalDocumentState) => {
    window.open(doc.source, '_blank');
  };

  return (
    <>
      <Row>
        <Text className={styles.color}>
          <Trans
            i18nKey={t('externalDocuments.title')}
            components={{ strong: <strong />, italic: <em /> }}
          />
        </Text>
      </Row>

      {showAdd && (
        <AddExternalDocumentButton
          referenceId={referenceId}
          className="mt-2 mb-3"
        />
      )}

      <ul className={styles.list}>
        {data.map((item) => (
          <li key={item.id} title={item.name}>
            <span className={styles.title}>
              <Button icon={<LinkOutlined />} type="link">
                <span className={styles.fileName}>
                  {t('externalDocuments.prefix')}: {item.name}
                </span>
              </Button>
            </span>
            <Space>
              <DeleteIconButton
                className={styles.delete}
                onClick={() => handleDelete(item)}
                entityName={t('externalDocuments.document')}
                confirm
              />
              <Button
                type="link"
                onClick={() => handleOpen(item)}
                className={styles.link}
              >
                {t('attach.openInNewTab')}
              </Button>
            </Space>
          </li>
        ))}
      </ul>
    </>
  );
}
